import src from "IMAGE";
export default { src, width: 960, height: 164, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAH0lEQVR42mP4//9/MRAnA3ESEMcBcSkQtwNxPhBnAwDI2BtVbL9rGwAAAABJRU5ErkJggg=="};
